import React, { useState, useEffect, useCallback } from 'react'
import { storeContext } from '../../context';
import { Layout, Button, Table, Col, Row, Form, Select, Input } from 'antd';
import translate from '../../i18n/translate';
import api from '../../helpers/api';
import { getError } from '../../helpers/verifyStatusErrorResponse';
import AlertNotAllow from '../AlertNotAllow';
import Confirm from '../Confirm/Confirm';
const { Content } = Layout;
const { Option } = Select;
const labelCol = {
  xs: 24,
  sm: 24,
  md: 8,
  lg: 8,
  xl: 6,
};

const labelColDes = {
  xs: 24,
  sm: 24,
  md: 16,
  lg: 18,
  xl: 14,
};

const types = [
  'onCreate',
  'onUpdate',
  'onDelete'
]; 
const INIT_VALUE = { type: null };

export default function AsScript() {
  const store = React.useContext(storeContext);
  const [data, setData] = useState([]);
  const [state, setState] = useState(INIT_VALUE);
  const [permission, setPermission] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);

  const columns = [
    {
      title: translate('default.description'),
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: translate('default.type'),
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: '',
      align: 'right',
      key: 'action',
      width: 200,
      render: (text, record, index) => (
        <>
          <Button icon="edit" type="default" onClick={() => setState({ ...record, index })} htmlType="button" style={{ marginRight: 10 }} />
          <Button icon="delete" type="danger" onClick={() => Confirm({ func: () => remove(index) })} htmlType="button" />
        </>
      ),
    }
  ];

  async function remove(index) {
    try {
      setLoading(true);
      await api.delete(`/as_script/${data[index].id}`);
      const temp = [...data];
      temp.splice(index, 1);
      setData(temp);
    } catch (e) {
      setPermission(getError(e, store));
    }
    setLoading(false);
  }

  async function onAdd() {
    const model = {
      ...state,
      as_type_id: store.currentItem.asTypeId
    }
    const result = await api.post('/as_script', model);
    state.id = result.data.result.id;
    const temp = [...data, state];
    setData(temp);
    setState(INIT_VALUE);
  }

  async function onUpdate() {
    const index = state.index;
    delete state.index;
    const model = {
      ...state,
      as_type_id: store.currentItem.asTypeId
    }
    await api.put(`/as_script/${state.id}`, model);
    data[index] = state;
    setData(data);
    setState(INIT_VALUE);
  }

  async function onSubmit(event) {
    event.preventDefault();
    try {
      const asScript = data.find(v => v.type.toUpperCase() === state.type.toUpperCase());
      if (asScript && asScript.id !== state.id) {
        store.error = { message: translate('asScript.typeAlreadyAdded') }
        return;
      }
      setLoadingButton(true);
      setLoading(true);
      if (state.id) {
        await onUpdate();
      } else {
        await onAdd();
      }
      store.success = { message: translate('asScript.save') }
    } catch (e) {
      setPermission(getError(e, store));
    }
    setLoadingButton(false);
    setLoading(false);
  }

  function isDisabled() {
    return !state || !state.description || !state.script || !state.type;
  }

  const initialize = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.get(`/as_script/as_type/${store.currentItem.asTypeId}`);
      if (data.data && data.data.result) {
        return setData(data.data.result);
      }
      setData([]);
    } catch (e) {
      setPermission(getError(e, store));
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [store.currentItem.asTypeId]);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <Content className="padding-20">
      {permission ?
        <>
          <Form layout="vertical" onSubmit={onSubmit}>
            <Row gutter={16}>
              <Col {...labelCol}>
                <Form.Item label="Type" required>
                  <Select defaultValue={null}
                    value={state.type} style={{ width: '100%' }}
                    onChange={(type) => setState(prevState => ({ ...prevState, type }))} >
                    <Option key={-1} value={null}>{translate('default.select.type')}</Option>
                    {types.map(x => <Option key={x}>{x}</Option>)}
                  </Select>
                </Form.Item>
              </Col>
              <Col {...labelColDes}>
                <Form.Item label={translate('default.description')} required>
                  <Input value={state.description}
                    onChange={(e) => {
                      const description = e.target.value;
                      setState(prevState => ({ ...prevState, description }));
                    }} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={20}>
                <Form.Item label="Script" required>
                  <Input.TextArea value={state.script} rows={4}
                    onChange={(e) => {
                      const script = e.target.value;
                      setState(prevState => ({ ...prevState, script }))
                    }} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col>
                <Form.Item>
                  <Button loading={loadingButton} type="primary" disabled={isDisabled()} htmlType="submit" >
                    {state.id ? translate('default.save') : translate('default.add')}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Col>
            <Table
              size="small"
              rowKey={record => record.key}
              columns={columns}
              dataSource={data}
              pagination={false}
              loading={loading}
            />
          </Col>
        </>
        : (
          <AlertNotAllow />
        )}
    </Content>
  )
}
